/**
 * URL of each entity's detail view. App.js turns these URLs into an initialDetailTarget
 * so the owning page opens the record. Shared by EntityLink, BackButton and useAppNavigate.
 */
export const ENTITY_PATHS = {
  'quote': (id) => `/quotes/${id}`,
  'sales-order': (id) => `/sales-orders/${id}`,
  'production-order': (id) => `/production-orders/${id}`,
  'task': (id) => `/tasks/${id}`,
  'inventory-item': (id) => `/inventory/items/${id}`,
  'invoice': (id) => `/invoices/${id}`,
  'customer': (id) => `/customers/${id}`,
};

export const entityPath = (type, id) => {
  const pathFn = ENTITY_PATHS[type];
  return pathFn && id != null && id !== '' ? pathFn(id) : null;
};

/**
 * location.state.returnTo for a detail opened from somewhere else.
 * - returnType/returnId: we come from another entity (BackButton reopens it)
 * - returnPath: we come from a dashboard or list URL (BackButton navigates there)
 * targetType/targetId tie it to the record being opened, so it is not reused for other records.
 */
export const buildReturnTo = ({ type, id, returnLabel, returnType, returnId, returnPath }) => (
  returnLabel
    ? {
        label: returnLabel,
        page: returnType || null,
        detailId: returnId ?? null,
        path: returnPath || null,
        targetType: type,
        targetId: id,
      }
    : undefined
);
